"use strict";
/* eslint-disable prefer-promise-reject-errors */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchProviderSaga = void 0;
const effects_1 = require("redux-saga/effects");
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const api_1 = require("astra-core/api");
const errors_1 = require("astra-core/utils/errors");
const selectors_1 = require("astra-core/containers/LanguagesProvider/selectors");
const types_1 = require("astra-core/containers/ConfigProvider/types");
const saga_1 = require("astra-core/containers/ConfigProvider/saga");
const dayjs_1 = __importDefault(require("dayjs"));
const EventsProvider_1 = require("astra-core/containers/EventsProvider");
const slice_1 = require("./slice");
const selectors_2 = require("./selectors");
const constants_1 = require("../constants");
const utils_1 = require("../utils");
const isFulfilled = (p) => p.status === 'fulfilled';
const mapResponses = (res) => {
    if (isFulfilled(res)) {
        return res.value;
    }
    else {
        return res.reason;
    }
};
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* fetchSearchMainSaga(action) {
    try {
        const eventsApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.EventsApi);
        const tournamentsApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.TournamentsApi);
        const locale = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const query = action.payload.search;
        const includeSubsports = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.GENERIC_SPORT_ENABLED);
        if (query.length > 2) {
            const eventsRequest = {
                locale,
                includeSubsports,
                statuses: constants_1.eventStatuses,
                pageSize: 20,
                searchQuery: query,
                searchQueryFields: [betweb_openapi_axios_1.SearchQueryField.CompetitorName],
                sort: [
                    'sportOrder.asc',
                    'groupOrder.asc',
                    'tournamentId.asc',
                    'scheduledAt.asc',
                ],
            };
            const lineRequest = Object.assign(Object.assign({}, eventsRequest), { live: false, scheduledFrom: (0, dayjs_1.default)().format(EventsProvider_1.DATE_FORMAT), hasLineOutcomes: true });
            const liveRequest = Object.assign(Object.assign({}, eventsRequest), { live: true, scheduledTo: (0, dayjs_1.default)().format(EventsProvider_1.DATE_FORMAT) });
            const tournamentsRequest = {
                locale,
                includeSubsports,
                eventStatuses: constants_1.eventStatuses,
                pageSize: 20,
                searchQuery: query,
                searchQueryFields: [betweb_openapi_axios_1.SearchQueryField.TournamentName],
            };
            const linePromise = new Promise((resolve, reject) => {
                eventsApi
                    .getEventsV2(lineRequest)
                    .then(({ data }) => {
                    resolve({ data, entryKey: 'lineEvents' });
                })
                    .catch(() => {
                    reject({ data: { items: [] }, entryKey: 'lineEvents' });
                });
            });
            const livePromise = new Promise((resolve, reject) => {
                eventsApi
                    .getEventsV2(liveRequest)
                    .then(({ data }) => {
                    resolve({ data, entryKey: 'liveEvents' });
                })
                    .catch(() => {
                    reject({ data: { items: [] }, entryKey: 'liveEvents' });
                });
            });
            const tournamentsPromise = new Promise((resolve, reject) => {
                tournamentsApi
                    .getTournamentsV2(tournamentsRequest)
                    .then(({ data }) => {
                    resolve({ data, entryKey: 'tournaments' });
                })
                    .catch(() => {
                    reject({ data: { items: [] }, entryKey: 'tournaments' });
                });
            });
            const responsePromises = yield Promise.allSettled([
                linePromise,
                livePromise,
                tournamentsPromise,
            ]);
            const result = responsePromises
                .map(mapResponses)
                .reduce((acc, cur) => {
                // eslint-disable-next-line
                // @ts-expect-error
                acc[cur.entryKey] = cur.data.items;
                return acc;
            }, {
                lineEvents: [],
                liveEvents: [],
                tournaments: [],
            });
            yield (0, effects_1.put)(slice_1.searchProviderActions.fetchSearchMainSuccess(result));
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        yield (0, effects_1.put)(slice_1.searchProviderActions.fetchSearchMainError(error));
    }
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* fetchTournamentsSaga() {
    try {
        const tournamentsApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.TournamentsApi);
        const locale = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const filters = yield (0, effects_1.select)(selectors_2.selectSearchPageFilters);
        const includeSubsports = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.GENERIC_SPORT_ENABLED);
        let allItems = [];
        const tournamentsRequest = (0, utils_1.buildTournamentsRequest)({
            locale,
            includeSubsports,
            sportIds: filters.sportIds,
            searchQuery: filters.searchQuery,
        });
        let pageKey;
        while (true) {
            const { data } = yield (0, effects_1.call)([tournamentsApi, tournamentsApi.getTournamentsV2], Object.assign(Object.assign({}, tournamentsRequest), { pageKey, sort: ['groupOrder.asc'] }));
            allItems = [...allItems, ...data.items];
            if (typeof data.paginationKey !== 'string') {
                break;
            }
            pageKey = data.paginationKey;
        }
        yield (0, effects_1.put)(slice_1.searchProviderActions.fetchTournamentsSuccess({ tournaments: allItems }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        yield (0, effects_1.put)(slice_1.searchProviderActions.fetchTournamentsError(error));
    }
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* searchProviderSaga() {
    yield (0, effects_1.all)([
        (0, effects_1.takeLatest)(slice_1.searchProviderActions.fetchSearchMain.type, fetchSearchMainSaga),
        (0, effects_1.takeEvery)(slice_1.searchProviderActions.fetchTournaments.type, fetchTournamentsSaga),
    ]);
}
exports.searchProviderSaga = searchProviderSaga;
//# sourceMappingURL=saga.js.map